import { render, staticRenderFns } from "./RegistrationDetail.vue?vue&type=template&id=578ae0cd&"
import script from "./RegistrationDetail.vue?vue&type=script&lang=js&"
export * from "./RegistrationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports